const KEY = 'cookMode';
const TIMEOUT_MS = 12 * 60 * 60 * 1000; // 12 hours

function isExpired(session) {
    return session._lastActivity && Date.now() - session._lastActivity > TIMEOUT_MS;
}

export function getSession() {
    try {
        const session = JSON.parse(sessionStorage.getItem(KEY)) || {};
        if (isExpired(session)) {
            sessionStorage.removeItem(KEY);
            window.dispatchEvent(new Event('cookSessionChanged'));
            return {};
        }
        return session;
    } catch {
        return {};
    }
}

function saveSession(session) {
    session._lastActivity = Date.now();
    sessionStorage.setItem(KEY, JSON.stringify(session));
    window.dispatchEvent(new Event('cookSessionChanged'));
}

export function getActiveRecipes() {
    const session = getSession();
    return Object.values(session).filter(v => typeof v === 'object' && v.recipe);
}

export function isInSession(recipeId) {
    return Boolean(getSession()[String(recipeId)]);
}

export function addToSession(recipe) {
    const session = getSession();
    const id = String(recipe.id);
    if (!session[id]) {
        session[id] = {
            recipe,
            checkedIngredients: [],
            checkedDirections: [],
            multiplier: 1,
            addedAt: Date.now(),
        };
        saveSession(session);
    }
}

export function setMultiplier(recipeId, multiplier) {
    const session = getSession();
    const entry = session[String(recipeId)];
    if (!entry) return;
    entry.multiplier = multiplier;
    saveSession(session);
}

export function clearSession() {
    sessionStorage.removeItem(KEY);
    window.dispatchEvent(new Event('cookSessionChanged'));
}

export function removeFromSession(recipeId) {
    const session = getSession();
    delete session[String(recipeId)];
    saveSession(session);
}

export function toggleIngredient(recipeId, ingredientIndex) {
    const session = getSession();
    const entry = session[String(recipeId)];
    if (!entry) return;
    const checked = new Set(entry.checkedIngredients);
    if (checked.has(ingredientIndex)) {
        checked.delete(ingredientIndex);
    } else {
        checked.add(ingredientIndex);
    }
    entry.checkedIngredients = Array.from(checked);
    saveSession(session);
}

export function toggleDirection(recipeId, directionIndex) {
    const session = getSession();
    const entry = session[String(recipeId)];
    if (!entry) return;
    const checked = new Set(entry.checkedDirections);
    if (checked.has(directionIndex)) {
        checked.delete(directionIndex);
    } else {
        checked.add(directionIndex);
    }
    entry.checkedDirections = Array.from(checked);
    saveSession(session);
}

export function getSessionEntry(recipeId) {
    return getSession()[String(recipeId)] || null;
}
